import { render, staticRenderFns } from "./AbstractSelectionQuestionView.vue?vue&type=template&id=e82fcef8&scoped=true&"
import script from "./AbstractSelectionQuestionView.vue?vue&type=script&lang=ts&"
export * from "./AbstractSelectionQuestionView.vue?vue&type=script&lang=ts&"
import style0 from "./AbstractSelectionQuestionView.vue?vue&type=style&index=0&id=e82fcef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82fcef8",
  null
  
)

export default component.exports